import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ColorModeScript } from '@chakra-ui/react';
import { config as configTema } from './theme/theme';
import './assets/css/App.css';
import { AuthContextProvider } from "./context";

import App from './App';

const isResizeObserverNoise = (message = '') => {
  const normalized = String(message || '');
  return (
    normalized.includes('ResizeObserver loop completed with undelivered notifications') ||
    normalized.includes('ResizeObserver loop limit exceeded')
  );
};

const suppressResizeObserverNoise = (event) => {
  const directMessage = event?.message;
  const nestedMessage = event?.error?.message;
  const reasonMessage = event?.reason?.message || event?.reason;
  const candidate = directMessage || nestedMessage || reasonMessage || '';

  if (!isResizeObserverNoise(candidate)) {
    return;
  }

  event.preventDefault?.();
  event.stopImmediatePropagation?.();
};

const installResizeObserverWorkaround = () => {
  if (typeof window === 'undefined' || typeof window.ResizeObserver !== 'function') {
    return;
  }

  const NativeResizeObserver = window.ResizeObserver;

  class SafeResizeObserver {
    constructor(callback) {
      this.observer = new NativeResizeObserver((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }

    observe(target, options) {
      this.observer.observe(target, options);
    }

    unobserve(target) {
      this.observer.unobserve(target);
    }

    disconnect() {
      this.observer.disconnect();
    }
  }

  window.ResizeObserver = SafeResizeObserver;
};

const patchConsoleForResizeObserverNoise = () => {
  const originalConsoleError = window.console.error;
  window.console.error = (...args) => {
    const message = args
      .map((value) => (typeof value === 'string' ? value : value?.message || ''))
      .join(' ');

    if (isResizeObserverNoise(message)) {
      return;
    }

    originalConsoleError(...args);
  };
};

window.addEventListener('error', suppressResizeObserverNoise, true);
window.addEventListener('unhandledrejection', suppressResizeObserverNoise, true);
installResizeObserverWorkaround();
patchConsoleForResizeObserverNoise();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    {/* Aplica el modo guardado (claro o noche) antes de pintar, sin parpadeo. */}
    <ColorModeScript initialColorMode={configTema.initialColorMode} />
    <AuthContextProvider>
      <App />
    </AuthContextProvider>
  </BrowserRouter>,
);
